import * as React from 'react'
import { useFormFactor } from 'hooks'
import { Button, IconButton } from 'cs-kevlar-react'
import clsx from 'clsx'

interface ResponsivePageActionButtonProps {
  onClick: () => void
  disabled?: boolean
  text: string
  color?: 'inherit' | 'primary' | 'secondary' | undefined
  phoneClassName?: string
  desktopClassName?: string
  tabletClassName?: string
  children: any
}

export const ResponsivePageActionButton: React.FunctionComponent<ResponsivePageActionButtonProps> = (
  props,
) => {
  const formFactor = useFormFactor()

  const {
    onClick,
    disabled,
    text,
    color,
    tabletClassName,
    desktopClassName,
    phoneClassName,
    children,
  } = props
  return (
    <React.Fragment>
      {!formFactor.isPhone && (
        <Button
          onClick={onClick}
          color={color}
          disabled={disabled}
          className={clsx(desktopClassName, tabletClassName)}
          aria-label={text}
        >
          {text}
        </Button>
      )}
      {formFactor.isPhone && (
        <IconButton
          onClick={onClick}
          color={color}
          disabled={disabled}
          className={phoneClassName}
          aria-label={text}
          size="large">
          {children}
        </IconButton>
      )}
    </React.Fragment>
  );
}
